import {
  BENCHMARK_MODE,
  CUSTOMER_SEGMENTATION_GRANULARITY_VIEWS,
  CUSTOMER_SEGMENTATION_SECTIONS,
  CUSTOMER_SEGMENTATION_TYPES,
  SALES_METRIC_SELECTOR,
  type BenchmarkMode,
  type CustomerSegmentationGranularity,
  type CustomerSegmentationSectionsType,
  type CustomerSegmentationType,
  type SalesMetricSelectorType
} from '@carrefour-gcs/shared';
import { defineStore } from 'pinia';

export { BENCHMARK_MODE, type BenchmarkMode } from '@carrefour-gcs/shared';

type CustomerSegmentationConfigType = {
  type: CustomerSegmentationType;
  granularity: CustomerSegmentationGranularity;
  sections: CustomerSegmentationSectionsType;
  benchmarkMode: BenchmarkMode;
};

type DynamicClientConfigType = {
  salesMetricSelector: SalesMetricSelectorType;
};

type ConfigStoreStateType = {
  customerSegmentation: CustomerSegmentationConfigType;
  dynamicClient: DynamicClientConfigType;
};

export const useConfigStore = defineStore('config', {
  state: (): ConfigStoreStateType => ({
    customerSegmentation: {
      type: CUSTOMER_SEGMENTATION_TYPES.CONSOSTYLE,
      granularity: CUSTOMER_SEGMENTATION_GRANULARITY_VIEWS.MACRO,
      sections: CUSTOMER_SEGMENTATION_SECTIONS.CA,
      benchmarkMode: BENCHMARK_MODE.CARREFOUR
    },
    dynamicClient: {
      salesMetricSelector: SALES_METRIC_SELECTOR.SALES
    }
  }),
  actions: {
    setCustomerSegmentationConfig(partial: Partial<CustomerSegmentationConfigType>) {
      this.customerSegmentation = { ...this.customerSegmentation, ...partial };
    },
    setDynamicClientConfig(partial: Partial<DynamicClientConfigType>) {
      this.dynamicClient = { ...this.dynamicClient, ...partial };
    }
  }
});
